import { render } from "./BorderWidth.vue?vue&type=template&id=7ae8763a&scoped=true&ts=true"
import script from "./BorderWidth.vue?vue&type=script&lang=ts"
export * from "./BorderWidth.vue?vue&type=script&lang=ts"

import "./BorderWidth.vue?vue&type=style&index=0&id=7ae8763a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae8763a"]])

export default __exports__